import React from "react";
import { authRoles } from "auth/authRoles";
import { Dashboard } from "./page/Dashboard";
// import { DashboardCopy } from "./page/DashboardCopy";

const DashboardRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
    // element: <DashboardCopy />,
    auth: authRoles.admin,
  },
];

export default DashboardRoutes;
